import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconFacilitySVG: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 40"
    >
      <path d="m19.94101,4.22753c-3.4889,0-6.31728,2.82831-6.31728,6.31728s2.82838,6.31728,6.31728,6.31728,6.31736-2.82838,6.31736-6.31728-2.82838-6.31728-6.31736-6.31728Zm-1.5764,6.69972c-.87057,0-1.5764-.70576-1.5764-1.5764s.70584-1.5764,1.5764-1.5764c.87065,0,1.5764.70576,1.5764,1.5764s-.70576,1.5764-1.5764,1.5764Z" />
      <path d="m31.07153,31.14534l-1.7677-1.76762c-.44344-.44344-1.04492-.69259-1.67201-.69259h-4.08762l-.35367-2.47606c-.05549-.38835-.38803-.67675-.78032-.67675h-.4987v-6.94635c-.63285.1552-1.29044.24663-1.97051.24663s-1.33766-.09143-1.97051-.24663v6.94635h-.4987c-.39221,0-.72475.2884-.78032.67675l-.35367,2.47606h-4.08762c-.62701,0-1.22849.24915-1.67193.69259l-1.7677,1.76762c-.44344.44352-.69259,1.04492-.69259,1.67201v1.36186c0,.87065.70584,1.5764,1.5764,1.5764h20.49326c.87065,0,1.5764-.70576,1.5764-1.5764v-1.36186c0-.62709-.24907-1.22849-.69251-1.67201Z" />
    </svg>
  );
};
